module.exports = __webpack_public_path__ + "img/inter-v11-latin-900.0069cd0.svg";